import { createFileRoute } from '@tanstack/react-router';
import { useLegacyMode } from '@/entities/legacy-mode';
import { DeliveryTariffsPage } from '@/pages/delivery-tariffs';
import { LegacyTariffsPage } from '@/pages/legacy-tariffs';
import { requireAuth } from '../require-auth';

export const Route = createFileRoute('/delivery/tariffs')({
  // Auth guard — see `require-auth.ts`. Runs before the component mounts,
  // so no query fires without a session.
  beforeLoad: requireAuth,
  component: DeliveryTariffsRoute,
});

function DeliveryTariffsRoute() {
  const legacy = useLegacyMode();
  return legacy ? <LegacyTariffsPage /> : <DeliveryTariffsPage />;
}
